export var CONTACT_URL = '/pages/contact-us';
export var ERROR_MESSAGE = 'There was an error loading data. Please come back later and try again.';
export var KUSTOMER_PUBLIC_API_URL = // eslint-disable-next-line max-len
'https://api.kustomerapp.com/v1/hooks/form/57e8a85974c4691000a28473/5933f132b64858cac9698f4ae64a4d560d7e2ef3f4d5a87f816b65430b25cbc1';
export var ROOT_URL = '/pages/help-center';
export var SHOP_MENS_URL = '/collections/shop-men';
export var SHOP_WOMENS_URL = '/collections/shop-women';
export var SIZE_GUIDE_QUESTION_ID = '63334bd87d734d324ae2f631';
export var SUGGEST = 'ov:suggest';